import { trpc } from "./trpc";
import type { SafeUser } from "../../../shared/types.js";

export function useAuth() {
  const meQuery = trpc.auth.me.useQuery(undefined, { retry: false });
  const logoutMutation = trpc.auth.logout.useMutation();

  const user: SafeUser | null = meQuery.data ?? null;
  const isLoading = meQuery.isLoading;
  const isAuthenticated = !!user;

  const logout = async () => {
    await logoutMutation.mutateAsync();
    meQuery.refetch();
  };

  return { user, isLoading, isAuthenticated, logout };
}
